import { lang } from '@umu/ukit-lang';
/**
 * @description 验证码回填与验证
 * @author wayou
 */

import './phoneVerification.scss';

import React, { Component, createRef, RefObject } from 'react';
import { classSet, $window } from '@umu/umu-dom';
import { components } from 'common';
const { Button } = components;
const { If } = components;

interface IProps {
    processing: boolean;
    areaCode: string;
    phoneNum: string;
    hasVoiceSMS: boolean;
    codeChangeCallback: (val: string) => void; // 验证码的同步
    codeVerifyCallback?: (code: string) => void; // 提交按钮的点击
    resendCallback: (isVoice?: boolean) => void; // 重新发送的点击
}
interface IState {
    timer: number;
    typedCode: string;
}

const RESEND_TIME = 60;

class PhoneVerification extends Component<IProps, IState> {
    public timerId: number = 0;
    public elRef: RefObject<HTMLInputElement>;

    constructor(props: IProps) {
        super(props);
        this.state = {
            timer: RESEND_TIME,
            typedCode: '',
        };

        this.elRef = createRef();

        this.verifyCode = this.verifyCode.bind(this);
        this.resend = this.resend.bind(this);
        this.getSmsCode = this.getSmsCode.bind(this);
        this.getVoiceCode = this.getVoiceCode.bind(this);
        this.codeInputChange = this.codeInputChange.bind(this);
    }

    public componentDidMount() {
        this.startTimer();

        const el = this.elRef.current;
        if (!el) {
            return;
        }
        el.focus();
    }

    public componentWillUnmount() {
        clearInterval(this.timerId);
    }

    public getSmsCode() {
        this.resend();
    }

    public getVoiceCode() {
        this.resend(true);
    }

    public resend(isVoice?: boolean) {
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        el.focus();

        const timer = this.state.timer;
        if (timer !== 0) {
            return;
        }
        this.props.resendCallback(isVoice); // resendCallback(isVoice)是否获取语音验证码
        // start counter
        this.startTimer();
    }

    public startTimer() {
        this.setState({
            timer: RESEND_TIME,
        });
        this.timerId = $window.setInterval(() => {
            if (this.state.timer > 0) {
                this.setState({
                    timer: this.state.timer - 1,
                });
            } else {
                clearInterval(this.timerId);
            }
        }, 1000);
    }

    public verifyCode() {
        const code = this.state.typedCode;
        if ((code || '').trim().length > 0 && this.props.codeVerifyCallback) {
            this.props.codeVerifyCallback(code);
        }
    }

    public codeInputChange() {
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        const value = el.value || '';
        this.setState({
            typedCode: value,
        });
        if (this.props.codeChangeCallback) {
            this.props.codeChangeCallback(value);
        }
    }

    public render() {
        const props = this.props;
        const { typedCode, timer } = this.state;

        // tslint:disable:max-line-length
        return (
            <div className="form phone-verification">
                <div className="form-body">
                    <div className="form-row">
                        <div className="input lined">
                            <input
                                type="text"
                                className="verify-code-input"
                                ref={this.elRef}
                                onChange={this.codeInputChange}
                            />
                        </div>
                    </div>
                    <div className="form-row verify-info">
                        <div className="verify-info-panel">
                            <p className="title">
                                {' '}
                                <span className="area-code">+{props.areaCode}</span> {props.phoneNum}{' '}
                            </p>
                            <p>{lang('短信验证码已发送，请填写验证码')}</p>
                        </div>
                    </div>
                </div>
                <div className="form-footer">
                    <If condition={!!props.codeVerifyCallback}>
                        <a
                            className={classSet({
                                'umu-btn': true,
                                'btn-primary': true,
                                'disabled': !(typedCode.trim().length > 0) || props.processing,
                            })}
                            onClick={this.verifyCode}
                        >
                            {lang('提交')}
                        </a>
                    </If>
                    <div className="form-info">
                        <p>
                            <span className="re-send-counter" style={{ display: timer > 0 ? 'inline' : 'none' }}>
                                {timer}{lang('秒')}...
                            </span>
                            <Button
                                className="re-send-btn"
                                alias="text"
                                size="small"
                                onClick={this.getSmsCode}
                                disabled={timer !== 0}
                            >
                                {lang('重新获取验证码')}
                            </Button>
                            <br />
                            <If condition={props.hasVoiceSMS}>
                                <Button
                                    className="re-send-btn"
                                    alias="text"
                                    size="small"
                                    onClick={this.getVoiceCode}
                                    disabled={timer !== 0}
                                >
                                    {lang('获取语音验证码')}
                                </Button>
                            </If>
                        </p>
                    </div>
                </div>
            </div>
        );
        // tslint:enable:max-line-length
    }
}

export default PhoneVerification;
